import React, { useCallback, useReducer } from 'react'
import { ModalBody, Form, FormGroup, Row, Col } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ValidationBoundary, ValidationState } from '@/components/validation'
import ErrorBoundary from '@/components/ErrorBoundary'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { intMaxValue } from '@/utils/constants'
import { InstitutionPermissionCheckBoxes } from './institutionPermissionCheckBoxes'
import PropTypes from 'prop-types'
import { getDefaultState, reducer, actionTypes } from './reducer'

const InternalPermissionDialog = React.memo(function InternalPermissionDialog ({ institutionPermission, onAction, ...props }) {
  const [state, dispatch] = useReducer(reducer, getDefaultState(institutionPermission, true))
  const { individualReadOnly, individualEdit, institutionReadOnly, institutionEdit } = state

  const individualReadOnlyChange = useCallback((value) => dispatch({ type: actionTypes.individualReadOnlyChange, data: value }), [])
  const individualEditChange = useCallback((value) => dispatch({ type: actionTypes.individualEditChange, data: value }), [])
  const institutionReadOnlyChange = useCallback((value) => dispatch({ type: actionTypes.institutionReadOnlyChange, data: value }), [])
  const institutionEditChange = useCallback((value) => dispatch({ type: actionTypes.institutionEditChange, data: value }), [])

  const onSave = useCallback(() => onAction({ ...state }), [onAction, state])

  return (
    <ValidationBoundary>
      <BasicHeader title='Permissions.InstitutionPermission' {...props} />
      <ModalBody>
        <ErrorBoundary>
          <Form>
            <Row>
              <Col>
                <FormGroup>
                  <InstitutionPermissionCheckBoxes
                    individualReadOnly={individualReadOnly || 0}
                    onIndividualReadOnlyChange={individualReadOnlyChange}
                    individualEdit={individualEdit || 0}
                    onIndividualEditChange={individualEditChange}
                    institutionReadOnly={institutionReadOnly || 0}
                    onInstitutionReadOnlyChange={institutionReadOnlyChange}
                    institutionEdit={institutionEdit || 0}
                    onInstitutionEditChange={institutionEditChange}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Form>
        </ErrorBoundary>
      </ModalBody>
      <ValidationState render={({ isValid }) =>
        <ConfirmFooter primaryButtonText={institutionPermission.id ? 'Common.Edit' : 'Common.Add'} icon='save' {...props} onAction={onSave} disabled={!isValid} />
      } />
    </ValidationBoundary>
  )
})

InternalPermissionDialog.propTypes = {
  institutionPermission: PropTypes.shape({
    id: PropTypes.number,
    jobPositionAssignmentId: PropTypes.number,
    institutionType: PropTypes.string,
    institution: PropTypes.object,
    bankType: PropTypes.string,
    companyType: PropTypes.string,
    ownershipType: PropTypes.string,
    individualReadOnly: PropTypes.number,
    individualEdit: PropTypes.number,
    institutionReadOnly: PropTypes.number,
    institutionEdit: PropTypes.number,
    isCbiPermission: PropTypes.bool
  }).isRequired,
  onAction: PropTypes.func.isRequired
}

export const maxInt = intMaxValue

export function getInstitutionPermissions (targetId, data) {
  return !targetId ? maxInt : data.getIn(['modifiedData', 'permissions'])
}

export default {
  modalProps: {
    size: 'lg'
  },
  component: InternalPermissionDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/institutionPermission/internalPermission.js